import React from "react";

import { Boxed } from "../../components/Boxed.components";
import { Button } from "../../components/Button.components";
import { PageTitle } from "../../components/style";
import { Tabs, Tab } from "react-bootstrap";
import Applications from "../Applications";
import { RequestTotalCard } from "../Dashboard/Dashboard";
import { Grid } from "../../components/Grid.components";

export const RequestManagement = (props) => {
  // state props
  const {
    isLoadingMy,
    myApplicationFormsList,
    myApplicationFormsTotal,
    openApplicationFormsList,
    openApplicationFormsTotal,
    closedApplicationFormsList,
    closedApplicationFormsTotal,

    fetchActionOpen,
    fetchActionClose,
    fetchActionMy,
    userAggerateRequest,
  } = props;

  // Dispatch props
  const { redirect } = props;

  console.log({ isLoadingMy })

  return (
    <>
      <Boxed pad="20px">
        <Boxed display="flex" justifyContent="space-between" margin="10px 0">
          <PageTitle>Request Management</PageTitle>
          <Button onClick={() => redirect("/requests/make")}>
            Make a New Request
          </Button>
        </Boxed>

        <Boxed pad="20px 0">
          <Tabs
            defaultActiveKey="my_request"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="my_request" title="My Request">
              <Grid
                desktop="repeat(4, 1fr)"
                tablet="repeat(3, 1fr)"
                mobile="repeat(1, 1fr)"
                margin="20px 0"
              >
                {userAggerateRequest?.map((request, index) => (
                  <RequestTotalCard key={index} status={request} />
                ))}
              </Grid>
              <Applications
                fetchActionURL={fetchActionMy}
                contentList={myApplicationFormsList}
                contentTotal={myApplicationFormsTotal}
              />
            </Tab>
            <Tab eventKey="open_request" title="Open Request">
              <Applications
                fetchActionURL={fetchActionOpen}
                contentList={openApplicationFormsList}
                contentTotal={openApplicationFormsTotal}
              />
            </Tab>
            <Tab eventKey="closed_request" title="Completed Request">
              <Applications
                fetchActionURL={fetchActionClose}
                contentList={closedApplicationFormsList}
                contentTotal={closedApplicationFormsTotal}
              />
            </Tab>
          </Tabs>
        </Boxed>
      </Boxed>
    </>
  );
};
